var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPeople(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 5.96675C14.95 5.95842 14.8917 5.95842 14.8417 5.96675C13.6917 5.92508 12.775 4.98342 12.775 3.81675C12.775 2.62508 13.7334 1.66675 14.925 1.66675C16.1167 1.66675 17.075 2.63342 17.075 3.81675C17.0667 4.98342 16.15 5.92508 15 5.96675Z",
    stroke: "#8490A5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1417 12.0333C15.2834 12.225 16.5417 12.025 17.425 11.4333C18.6 10.65 18.6 9.36664 17.425 8.58331C16.5334 7.99164 15.2584 7.79163 14.1167 7.99163",
    stroke: "#8490A5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.97503 5.96675C5.02503 5.95842 5.08336 5.95842 5.13336 5.96675C6.28336 5.92508 7.20002 4.98342 7.20002 3.81675C7.20002 2.62508 6.24169 1.66675 5.05003 1.66675C3.85836 1.66675 2.90002 2.63342 2.90002 3.81675C2.90836 4.98342 3.82503 5.92508 4.97503 5.96675Z",
    stroke: "#8490A5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.83334 12.0333C4.69168 12.225 3.43335 12.025 2.55001 11.4333C1.37501 10.65 1.37501 9.36664 2.55001 8.58331C3.44168 7.99164 4.71668 7.79163 5.85834 7.99163",
    stroke: "#8490A5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99996 12.1916C9.94996 12.1833 9.89163 12.1833 9.84163 12.1916C8.69163 12.1499 7.77496 11.2083 7.77496 10.0416C7.77496 8.84994 8.7333 7.8916 9.92496 7.8916C11.1166 7.8916 12.075 8.85827 12.075 10.0416C12.0666 11.2083 11.15 12.1583 9.99996 12.1916Z",
    stroke: "#8490A5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.57498 14.8166C6.39998 15.5999 6.39998 16.8832 7.57498 17.6666C8.90831 18.5582 11.0916 18.5582 12.425 17.6666C13.6 16.8832 13.6 15.5999 12.425 14.8166C11.1 13.9332 8.90831 13.9332 7.57498 14.8166Z",
    stroke: "#8490A5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeople);
export default __webpack_public_path__ + "static/media/people.e70cc8b4d0837ed123810af795f3d5d6.svg";
export { ForwardRef as ReactComponent };